<div mat-dialog-content>
    <h2>Seçilen statü : {{ data.name }}</h2>
    
    <!-- Add message for Journey status -->
    <div *ngIf="isJourney" class="warningText">
        <p>Yolculuk devam ettiği için statü değişikliği yapılamamaktadır. Rezervasyon sonlandırıldıktan sonra statü değişikliği yapılabilir.</p>
    </div>

    <div class="carDate" *ngIf="!isJourney">
        <ul>
            <li>Eğer daha önce bir atama yapıldı ise önceki silinip yeni atama yapılır, yani bir araca 2 kez farklı tarihlerde statü atayamazsınız.</li>
            <li>Başlama tarihi gelene kadar aracın statüsü devam eder. O saatte aracın statüsü seçtiğiniz {{ data.name }} değere gelir. Bitiş tarihinde ise tekrardan araç OPEN değerine dönecektir.</li>
            <li>Eğer aracın statüsü sürekli olarak kalmasını istiyorsanız tarih seçimi yapmayınız.</li>
        </ul>
        <form [formGroup]="range">
            <mat-form-field appearance="fill">
                <mat-label>Başlama Tarihi</mat-label>
                <input matInput placeholder="Başlama Tarihi" formControlName="start" type="datetime-local">
            </mat-form-field>
    
            <mat-form-field appearance="fill">
                <mat-label>Bitiş Tarihi</mat-label>
                <input matInput placeholder="Bitiş Tarihi" formControlName="end" type="datetime-local">
            </mat-form-field>
        </form>
    </div>

    <!-- Added Reservations Table -->
    <div *ngIf="activeReservations.length > 0 && !isJourney">
        <h3>Aktif Rezervasyonlar</h3>
        <div class="tableCtr">
            <table mat-table [dataSource]="activeReservations">
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef>ID</th>
                <td mat-cell *matCellDef="let element">{{element.id}}</td>
            </ng-container>

            <ng-container matColumnDef="user_full_name">
                <th mat-header-cell *matHeaderCellDef>Kullanıcı</th>
                <td mat-cell *matCellDef="let element">{{element.user.name}} {{element.user.surname}}</td>
            </ng-container>

            <ng-container matColumnDef="start_time">
                <th mat-header-cell *matHeaderCellDef>Başlama Tarihi</th>
                <td mat-cell *matCellDef="let element">{{element.start_time}}</td>
            </ng-container>

            <ng-container matColumnDef="end_time">
                <th mat-header-cell *matHeaderCellDef>Bitiş Tarihi</th>
                <td mat-cell *matCellDef="let element">{{element.end_time}}</td>
            </ng-container> 

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
    </div>
</div>
<p *ngIf="activeReservations.length > 0 && !isJourney" class="warningText">
    Araç kullanım dışına alındığında yukarıdaki listelenmiş rezervasyonlar iptal edilecektir. 
    İşleme devam etmek istediğinize emin misiniz?
</p>
<div mat-dialog-actions class="dialogBtnCtr">
    <button class="cancelBtn" (click)="dialogRef.close()">Cancel</button>
    <button class="okBtn" (click)="closeDialog()" color="primary" cdkFocusInitial *ngIf="!isJourney">Submit</button>
</div>